import { render, staticRenderFns } from "./DucsPermits.vue?vue&type=template&id=28ea86f1"
import script from "./DucsPermits.vue?vue&type=script&lang=js"
export * from "./DucsPermits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports